import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";

// Ends the session when the stored tokens are gone/expired, and keeps tabs in sync.
export const useSessionSync = (user) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) return;
    const expiry = localStorage.getItem("refreshTokenExpiry");
    const expired = expiry && new Date(expiry).getTime() <= Date.now();
    if (!localStorage.getItem("token") || expired) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("refreshTokenExpiry");
      dispatch(logout());
    }
  }, [user, dispatch]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== "token" && e.key !== null) return;
      // Logged out (or storage cleared) in another tab
      if (!e.newValue) dispatch(logout());
      // Logged in from another tab while this one is signed out
      else if (!user) window.location.reload();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [user, dispatch]);
};
